import { render, staticRenderFns } from "./cPagination.vue?vue&type=template&id=a98442fe&scoped=true"
import script from "./cPagination.vue?vue&type=script&lang=js"
export * from "./cPagination.vue?vue&type=script&lang=js"
import style0 from "./cPagination.vue?vue&type=style&index=0&id=a98442fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98442fe",
  null
  
)

export default component.exports